import React from "react";
import { Box, Typography, Avatar, Grid, ListItem, List, Tooltip, capitalize } from "@mui/material";
import RectangleIcon from "@mui/icons-material/Rectangle";
import moment from "moment";
import { useNavigate } from "react-router-dom";

interface DataSourcesRequestsTableProps {
    dataSources: any[];
    resourceStatuses: any[];
}

const DataSourcesRequestsTable: React.FC<DataSourcesRequestsTableProps> = ({
    dataSources, 
    resourceStatuses
}: DataSourcesRequestsTableProps) => {
    const [cardHoverIndex, setCardHoverIndex] = React.useState<number | null>(null);
    const navigate = useNavigate();
        
    return (
        <List sx={{ bgcolor: "#fafafa" }}>
            <ListItem sx={{ bgcolor: "#f2f2f2", borderRadius: "4px" }}>
                <Box width="100%">
                    <Grid container direction="row" alignItems="center">
                        <Grid item xs={2.5}><Typography fontSize="12px">DATA SOURCE NAME</Typography></Grid>
                        <Grid item xs={1.5}><Typography fontSize="12px">DATA SOURCE TYPE</Typography></Grid>
                        <Grid item xs={2}><Typography fontSize="12px">CLOUD IDENTIFIER</Typography></Grid>
                        <Grid item textAlign="start" xs={1.5}><Typography fontSize="12px">OWNER</Typography></Grid>
                        <Grid item textAlign="start" xs={2}><Typography fontSize="12px">REQUESTED ON</Typography></Grid>
                        <Grid textAlign="start" item xs={1.5}><Typography fontSize="12px">ACTIONED BY/ REASON</Typography></Grid>
                        <Grid item textAlign="start" xs={1}><Typography fontSize="12px">ACTIONED ON</Typography></Grid>
                    </Grid>
                </Box>
            </ListItem>
            {dataSources.map((dataSource: any, index: number) => (
                <ListItem
                    key={dataSource.id}
                    sx={{
                        border: cardHoverIndex === index ? "1px solid #000" : "1px solid #00000000",
                        mt: 1,
                        cursor: "pointer",
                        bgcolor: dataSource.status === "active" || dataSource.status === "approved" ? "#FFFFFF" : dataSource.status === "rejected" ? "#F0443810" : "#FDB02210",
                        borderRadius: "8px",
                    }}
                    onClick={() => {
                        navigate(`/datasolutions/requests/data-sources/${dataSource.id}`); 
                    }}
                    onMouseEnter={() => setCardHoverIndex(index)}
                    onMouseLeave={() => { setCardHoverIndex(null); }}
                >
                    <Box width="100%" sx={{}}>
                        <Grid container direction="row" alignItems="center" justifyContent="space-between">
                            <Grid item xs={2.5}>
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <RectangleIcon sx={{ color: dataSource.status === "active" || dataSource.status === "approved" ? "#12B76A" : dataSource.status === "rejected" ? "#F04438" : "#FDB022", bgcolor: dataSource.status === "active" || dataSource.status === "approved" ? "#12B76A" : dataSource.status === "rejected" ? "#F04438" : "#FDB022", width: "4px", marginRight: "8px" }} />
                                    <Typography fontSize="14px" fontFamily="Gilroy-Medium">{dataSource.dataSourceName}</Typography>
                                    {(dataSource.status === 'active' || dataSource.status === 'approved') && resourceStatuses && resourceStatuses.length > 0 ? ( 
                                        <Tooltip sx={{ whiteSpace: "pre-line" }} title={ <Box key={`${dataSource.id}-tooltip`}>Current Status<br />{resourceStatuses.filter((e:any) => e.resourceId === dataSource.id).map((e: any, i: number) => ( <React.Fragment key={`${dataSource.id}-status-${i}`}>{capitalize(e.currentStatus)}<br /></React.Fragment> ))}</Box> }>
                                            <Avatar src="/assets/info.svg" alt="info" sx={{ height: 16, width: 16, marginLeft: "4px" }} />
                                        </Tooltip>
                                    ) : null}
                                </Box>
                            </Grid>
                            {/* Replaced solutionCategoryType with resourceSpecType */}
                            <Grid item xs={1.5}><Typography fontSize="14px" fontFamily="Gilroy-Regular">{dataSource.resourceSpecType || 'N/A'}</Typography></Grid>
                            <Grid item xs={2}><Typography fontSize="14px" fontFamily="Gilroy-Regular" sx={{ textTransform: 'uppercase' }}>{dataSource.cloudProvider || 'N/A'}</Typography></Grid>
                            <Grid item xs={1.5}>
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <Avatar src={dataSource.dataSourceOwnerAvatar} alt={dataSource.dataSourceOwnerName} sx={{ marginRight: "8px", height: 30, width: 30 }}>{dataSource.dataSourceOwnerName ? dataSource.dataSourceOwnerName.charAt(0).toUpperCase() : ''}</Avatar>
                                    <Typography fontSize="14px" fontFamily="Gilroy-Regular">{dataSource.dataSourceOwnerName}</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={2}>
                                <Box display="flex" alignItems="center"><Typography fontSize="14px" fontFamily="Gilroy-Regular">{dataSource.createdAt ? moment(dataSource.createdAt).format("DD/MM/YYYY | hh:mm A") : 'N/A'}</Typography></Box>
                            </Grid>
                            <Grid item xs={1.5}>
                                {dataSource.status !== "pending" && (
                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                        {dataSource.dataSourceApproverName &&
                                            <Avatar src={dataSource.dataSourceApproverAvatar} alt={dataSource.dataSourceApproverName} sx={{ marginRight: "8px", height: 30, width: 30 }}>{dataSource.dataSourceApproverName.charAt(0).toUpperCase()}</Avatar>
                                        }
                                        {dataSource.dataSourceApproverName &&
                                            <Typography fontSize="14px" fontFamily="Gilroy-Regular" mr={1}>{dataSource.dataSourceApproverName}</Typography>
                                        }
                                        {dataSource.status === "rejected" && dataSource.reasonForRejection && (
                                            <Tooltip title={`Reason: ${dataSource.reasonForRejection}`}><img src="/assets/info.svg" alt="info" /></Tooltip>
                                        )}
                                    </Box>
                                )}
                            </Grid>
                            <Grid item xs={1}>
                                {(dataSource.status !== "pending" && dataSource.actionedAt) && (
                                    <Box display="flex" alignItems="center"><Typography fontSize="14px" fontFamily="Gilroy-Regular">{moment(dataSource.actionedAt).format("DD/MM/YYYY | hh:mm A")}</Typography></Box>
                                )}
                            </Grid>
                        </Grid>
                    </Box>
                </ListItem>
            ))}
        </List>
    );
};

export default DataSourcesRequestsTable;



// import React from "react";
// import { Box, Typography, Avatar, Grid, ListItem, List, Tooltip, capitalize } from "@mui/material";
// import RectangleIcon from "@mui/icons-material/Rectangle";
// import moment from "moment";
// import { useNavigate } from "react-router-dom";

// interface DataSourcesRequestsTableProps {
//     dataSources: any[];
//     resourceStatuses: any[];
// }

// const DataSourcesRequestsTable: React.FC<DataSourcesRequestsTableProps> = ({
//     dataSources, 
//     resourceStatuses
// }: DataSourcesRequestsTableProps) => {
//     const [cardHoverIndex, setCardHoverIndex] = React.useState<number | null>(null);
//     const navigate = useNavigate();
        
//     return (
//         <List sx={{ bgcolor: "#fafafa" }}>
//             <ListItem sx={{ bgcolor: "#f2f2f2", borderRadius: "4px" }}>
//                 <Box width="100%">
//                     <Grid container direction="row" alignItems="center">
//                         <Grid item xs={2}><Typography fontSize="12px">DATA SOURCE NAME</Typography></Grid>
//                         <Grid item xs={1.5}><Typography fontSize="12px">APPLICATION</Typography></Grid>
//                         <Grid item xs={1.5}><Typography fontSize="12px">CATEGORY TYPE</Typography></Grid>
//                         <Grid item xs={1.5}><Typography fontSize="12px">CLOUD IDENTIFIER</Typography></Grid>
//                         <Grid item textAlign="start" xs={1.5}><Typography fontSize="12px">OWNER</Typography></Grid>
//                         <Grid item textAlign="start" xs={1.5}><Typography fontSize="12px">REQUESTED ON</Typography></Grid>
//                         <Grid textAlign="start" item xs={1.5}><Typography fontSize="12px">ACTIONED BY/ REASON</Typography></Grid>
//                         <Grid item textAlign="start" xs={1}><Typography fontSize="12px">ACTIONED ON</Typography></Grid>
//                     </Grid>
//                 </Box>
//             </ListItem>
//             {dataSources.map((dataSource: any, index: number) => (
//                 <ListItem
//                     key={dataSource.id}
//                     sx={{
//                         border: cardHoverIndex === index ? "1px solid #000" : "1px solid #00000000",
//                         mt: 1,
//                         cursor: "pointer",
//                         bgcolor: dataSource.status === "active" || dataSource.status === "approved" ? "#FFFFFF" : dataSource.status === "rejected" ? "#F0443810" : "#FDB02210",
//                         borderRadius: "8px",
//                     }}
//                     onClick={() => {
//                         navigate(`/datasolutions/requests/data-sources/${dataSource.id}`); 
//                     }}
//                     onMouseEnter={() => setCardHoverIndex(index)}
//                     onMouseLeave={() => { setCardHoverIndex(null); }}
//                 >
//                     <Box width="100%" sx={{}}>
//                         <Grid container direction="row" alignItems="center" justifyContent="space-between">
//                             <Grid item xs={2}>
//                                 <Box sx={{ display: "flex", alignItems: "center" }}>
//                                     <RectangleIcon sx={{ color: dataSource.status === "active" || dataSource.status === "approved" ? "#12B76A" : dataSource.status === "rejected" ? "#F04438" : "#FDB022", bgcolor: dataSource.status === "active" || dataSource.status === "approved" ? "#12B76A" : dataSource.status === "rejected" ? "#F04438" : "#FDB022", width: "4px", marginRight: "8px" }} />
//                                     <Typography fontSize="14px" fontFamily="Gilroy-Medium">{dataSource.dataSourceName}</Typography>
//                                     {(dataSource.status === 'active' || dataSource.status === 'approved') && resourceStatuses && resourceStatuses.length > 0 ? ( 
//                                         <Tooltip sx={{ whiteSpace: "pre-line" }} title={ <Box key={`${dataSource.id}-tooltip`}>Current Status<br />{resourceStatuses.filter((e:any) => e.resourceId === dataSource.id).map((e: any, i: number) => ( <React.Fragment key={`${dataSource.id}-status-${i}`}>{capitalize(e.currentStatus)}<br /></React.Fragment> ))}</Box> }>
//                                             <Avatar src="/assets/info.svg" alt="info" sx={{ height: 16, width: 16, marginLeft: "4px" }} />
//                                         </Tooltip>
//                                     ) : null}
//                                 </Box>
//                             </Grid>
//                             <Grid item xs={1.5}><Typography fontSize="14px" fontFamily="Gilroy-Regular">{dataSource.applicationName || 'N/A'}</Typography></Grid>
//                             <Grid item xs={1.5}><Typography fontSize="14px" fontFamily="Gilroy-Regular">{dataSource.solutionCategoryType || 'N/A'}</Typography></Grid>
//                             <Grid item xs={1.5}><Typography fontSize="14px" fontFamily="Gilroy-Regular" sx={{ textTransform: 'uppercase' }}>{dataSource.cloudProvider || 'N/A'}</Typography></Grid>
//                             <Grid item xs={1.5}>
//                                 <Box sx={{ display: "flex", alignItems: "center" }}>
//                                     <Avatar src={dataSource.dataSourceOwnerAvatar} alt={dataSource.dataSourceOwnerName} sx={{ marginRight: "8px", height: 30, width: 30 }}>{dataSource.dataSourceOwnerName ? dataSource.dataSourceOwnerName.charAt(0).toUpperCase() : ''}</Avatar>
//                                     <Typography fontSize="14px" fontFamily="Gilroy-Regular">{dataSource.dataSourceOwnerName}</Typography>
//                                 </Box>
//                             </Grid>
//                             <Grid item xs={1.5}>
//                                 <Box display="flex" alignItems="center"><Typography fontSize="14px" fontFamily="Gilroy-Regular">{dataSource.createdAt ? moment(dataSource.createdAt).format("DD/MM/YYYY | hh:mm A") : 'N/A'}</Typography></Box>
//                             </Grid>
//                             <Grid item xs={1.5}>
//                                 {dataSource.status !== "pending" && (
//                                     <Box sx={{ display: "flex", alignItems: "center" }}>
//                                         {dataSource.dataSourceApproverName &&
//                                             <Avatar src={dataSource.dataSourceApproverAvatar} alt={dataSource.dataSourceApproverName} sx={{ marginRight: "8px", height: 30, width: 30 }}>{dataSource.dataSourceApproverName.charAt(0).toUpperCase()}</Avatar>
//                                         }
//                                         {dataSource.dataSourceApproverName &&
//                                             <Typography fontSize="14px" fontFamily="Gilroy-Regular" mr={1}>{dataSource.dataSourceApproverName}</Typography>
//                                         }
//                                         {dataSource.status === "rejected" && dataSource.reasonForRejection && (
//                                             <Tooltip title={`Reason: ${dataSource.reasonForRejection}`}><img src="/assets/info.svg" alt="info" /></Tooltip>
//                                         )}
//                                     </Box>
//                                 )}
//                             </Grid>
//                             <Grid item xs={1}>
//                                 {(dataSource.status !== "pending" && dataSource.actionedAt) && (
//                                     <Box display="flex" alignItems="center"><Typography fontSize="14px" fontFamily="Gilroy-Regular">{moment(dataSource.actionedAt).format("DD/MM/YYYY | hh:mm A")}</Typography></Box>
//                                 )}
//                             </Grid>
//                         </Grid>
//                     </Box>
//                 </ListItem>
//             ))}
//         </List>
//     );
// };

// export default DataSourcesRequestsTable;